import { MY_FLEET_STATE } from 'features/myFleet';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useActiveDisplay = () => {
  const activeDisplay = useSelector((state: RootState) => state[MY_FLEET_STATE].activeDisplay);

  return activeDisplay;
};

export const useIsSelectedCar = () => {
  const selectedCar = useSelector((state: RootState) => state[MY_FLEET_STATE].selectedCar);

  return !!selectedCar;
};

export const useSelectedCar = () => {
  const selectedCar = useSelector((state: RootState) => state[MY_FLEET_STATE].selectedCar);

  return selectedCar;
};

export const useSearchValue = () => {
  const searchValue = useSelector((state: RootState) => state[MY_FLEET_STATE].searchValue);
  return searchValue;
};

export const useFilterMyFleet = () => {
  const myFleetFilter = useSelector((state: RootState) => state[MY_FLEET_STATE].filter);
  return myFleetFilter;
};

export const useSelectedMobileLocation = () => {
  const selectedMobileLocation = useSelector((state: RootState) => state[MY_FLEET_STATE].selectedMobileLocation);
  return selectedMobileLocation;
};
